import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SEOserviceService {

  constructor(private titleService: Title, private metaService: Meta) { }

  public setMetadata(title: string, desc: string, keyword: string) {
    this.titleService.setTitle(title);
    this.metaService.addTags([
      { name: 'keywords', content: keyword },
      { name: 'description', content: desc },
    ]);

  }
}

